import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain , isKsDomain , isSaficDomain} from 'utils/domain'

import Icon, { IconProps } from './Icon'

/**
 * フラグアイコン
 */
const FlagIcon: React.FC<IconProps> = (props) => {
  const color = isKsDomain() ? 'var(--color-text)' : isSaficDomain() ? 'var(--color-text-for-main-background)' :{
    [DOMAIN.SJ]: 'var(--color-text)',
  }[getDomain()]

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="88.235"
        height="100"
        viewBox="0 0 88.235 100"
      >
        <path
          fill={color}
          d="M48.294,15.765l2.353,11.765H81.471V62.824H61.706L59.353,51.059H16.765V15.765H48.294M57.941,4H5V104H16.765V62.824H49.706l2.353,11.765H93.235V15.765H60.294Z"
          transform="translate(-5 -4)"
        />
      </svg>
    </Icon>
  )
}

export default FlagIcon
